import ApiService from "@/core/services/api.service";
import JwtService from "@/core/services/jwt.service";

const state = {};

const getters = {};

const mutations = {};

const actions = {
    getRepresentantesBox(context, dados) {
        return new Promise(resolve => {
            if (JwtService.getToken()) {
                ApiService.setHeader();
                ApiService.post("representantes/access/listaBox", dados).then(({ data }) => {
                    resolve(data);
                });
            }
        });
    }, 
    async getRepresentantesAvisoPEP() {
        if(!JwtService.getToken()) { throw new Error("Sessão indisponível para concluir a saída."); }
        ApiService.setHeader();
        const { data } = await ApiService.query("representantes/access/listarRepresentantesAvisoPEP", { timeout: 30000 });
        if(!Array.isArray(data)) { throw new Error("Resposta inválida ao consultar os destinatários do aviso."); }
        return data;
    }
};

export default {
    state,
    actions,
    mutations,
    getters
};